import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { OfficeType } from "@type/inventory/office";
import { IconEdit01 } from "@pentabd/icons";

export const BuildingTableColumn = (
  t: TFunction<"translation", undefined>,
  handleScrollToTop: () => void,
  handleQueryById: (id: string | number) => void,
) => {
  return [
    {
      id: 1,
      key: "buildingName",
      name: t("INVENTORY_ROOM_CONFIG.BUILDING.TABLE_COLUMN.BUILDING_NAME"),
      render: (buildingName: string) => (
        <Text color="subtitle1">{buildingName}</Text>
      ),
    },
    {
      //   id: 2,
      //   key: "officeName",
      //   name: t("INVENTORY_ROOM_CONFIG.BUILDING.TABLE_COLUMN.OFFICE_NAME"),
      //   render: (__: any, row: BuildingType) => {
      //     return <Text>{row.officeAddress.name}</Text>;
      //   },
      id: 2,
      key: "officeAddress",
      name: t("INVENTORY_ROOM_CONFIG.BUILDING.TABLE_COLUMN.OFFICE_NAME"),
      render: (officeAddress: OfficeType) => (
        <Text color="subtitle1">{officeAddress.name}</Text>
      ),
    },
    {
      id: 3,
      key: "floorCount",
      name: t("INVENTORY_ROOM_CONFIG.BUILDING.TABLE_COLUMN.NO_OF_FLOOR"),
      render: (floorCount: number) => (
        <Text color="subtitle1">{floorCount}</Text>
      ),
    },
    {
      id: 4,
      key: "id",
      name: "",
      render: (id: number | string) => {
        return (
          <div
            onClick={() => {
              handleScrollToTop();
              handleQueryById(id);
            }}
            className="cursor-pointer"
          >
            <IconEdit01 size={24} />
          </div>
        );
      },
    },
  ];
};
